"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportingYearAddApi = reportingYearAddApi;
exports.reportingYearFindsCurrentFiscalYearByOrgIdApi = reportingYearFindsCurrentFiscalYearByOrgIdApi;
exports.reportingYearListApi = reportingYearListApi;
exports.reportingYearListDeleteApi = reportingYearListDeleteApi;
exports.reportingYearReportNotExistListApi = reportingYearReportNotExistListApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * report not exist list
 * @param payload
 * @returns api response
 * @description this function used to get repost not exist.
 */
function reportingYearReportNotExistListApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.reportingYear.reportNotExistList));
}

/**
 * finds current fiscal year by orgId
 * @param payload
 * @returns api response
 * @description this function used to finds current fiscal year by orgId.
 */
function reportingYearFindsCurrentFiscalYearByOrgIdApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.reportingYear.reportingYearFindsCurrentFiscalYear));
}

/**
 * finds current fiscal year by orgId
 * @param payload
 * @returns api response
 * @description this function used to finds current fiscal year by orgId.
 */
function reportingYearListApi() {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.reportingYear.list));
}

/**
 * finds current fiscal year by orgId
 * @param payload
 * @returns api response
 * @description this function used to finds current fiscal year by orgId.
 */
function reportingYearAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ReportDataService.reportingYear.add), params);
}

/**
 * finds current fiscal year by orgId
 * @param payload
 * @returns api response
 * @description this function used to finds current fiscal year by orgId.
 */
function reportingYearListDeleteApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ReportDataService.reportingYear.deleteList), params);
}